import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "_mb-3",
  "data-qa": "cart-table-item-list:box"
}
const _hoisted_2 = {
  key: 0,
  class: "gfu-bt--b2 _tc--light _ttu _fw-n _lts-2"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_skeleton_media_object = _resolveComponent("skeleton-media-object")
  const _component_cart_table_product_order_item = _resolveComponent("cart-table-product-order-item")
  const _component_cart_table_custom_order_item = _resolveComponent("cart-table-custom-order-item")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isOpenForOrders)
      ? (_openBlock(), _createBlock(_component_base_notificator, {
          key: 0,
          type: "info",
          "can-close": false,
          class: "_my-4",
          "data-qa": "notificator-item-info:ProjectDoesNotAcceptPledges"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.Resources.YourPledge.NoNewOrdersInfoToast), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($options.skeletonItems.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.skeletonItems, (i) => {
            return (_openBlock(), _createBlock(_component_skeleton_media_object, { key: i }))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.groupedOrderItems, (group) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.title,
        class: "_mb-3",
        "data-qa": "cart-table-item-list:box"
      }, [
        ($options.groupedOrderItems.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(group.title), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.productOrderItems, (item) => {
          return (_openBlock(), _createBlock(_component_cart_table_product_order_item, _mergeProps({
            key: item.orderItemID
          }, { ref_for: true }, item, {
            onEdit: $options.onEdit,
            onRemove: $event => ($options.onRemove(item.orderItemId)),
            onEditPledge: $options.onEditPledge,
            "data-qa": `cart-table-order-item:${item.orderItemId}`
          }), null, 16 /* FULL_PROPS */, ["onEdit", "onRemove", "onEditPledge", "data-qa"]))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.customOrderItems, (item) => {
          return (_openBlock(), _createBlock(_component_cart_table_custom_order_item, _mergeProps({
            key: item.orderItemID
          }, { ref_for: true }, item, {
            onRemove: $event => ($options.onRemove(item.orderItemId)),
            "data-qa": `cart-table-order-item:${item.orderItemId}`
          }), null, 16 /* FULL_PROPS */, ["onRemove", "data-qa"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}